module.exports = __webpack_public_path__ + "media/Loops Woodwinds.3994e348.wav";